import { createStore } from "vuex";

import languageBtnModule from "./modules/language/index.js";
import mineralsModule from "./modules/minerals/index.js";
import rocksModule from "./modules/rocks/index.js";

const store = createStore({
  modules: {
    language: languageBtnModule,
    minerals: mineralsModule,
    rocks: rocksModule,
  },
});

export default store;
